// Libraries.
import { useEffect, useState } from "react";
// Provider.
import { Provider } from "react-redux";
// Store.
import { store } from "./store/store";
// Components
import { HeaderNavbar } from "./features/HeaderNavbar";
import { Footer } from "./features/Footer";
import { LandingPage } from "./Pages/LandingPage/LandingPage";
// styles.
import { GlobalStyle } from "./styles";

const App: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Provider store={store}>
      <GlobalStyle />
      <div className="App">
        <HeaderNavbar scrolled={scrolled} />
        <LandingPage />
        <Footer />
      </div>
    </Provider>
  );
};

export default App;
